import React from 'react'

function ProgressMark() {
	return (
		<svg width="15" height="12" viewBox="0 0 2 8" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="0.304688" width="1.15591" height="8" rx="0.577957" fill="white" fill-opacity="0.5" />
		</svg>
	)
}

export default ProgressMark
